import { createComponent } from 'packages/components/src';

const Pulser = createComponent('div', {
  className: 'animate-pulse rounded-lg bg-[#F4F8FA]'
});

export const Tile = createComponent('div', {
  className:
    'w-[300px] rounded-lg border border-border-subtle text-text-strong sm:w-[221px] md:w-[300px]'
});

export const TileImageSection = createComponent('section', {
  className:
    'relative h-[168px] overflow-hidden rounded-[8px_8px_0_0] sm:h-[123px] md:h-[168px]'
});

export const TileInfoSection = createComponent('section', {
  className: 'p-xl'
});

export const YearMakeModel = createComponent('p', {
  className: 'overflow-hidden text-ellipsis whitespace-nowrap t-strong-lg'
});

export const TrimMileage = createComponent('p', {
  className: 'mb-xl flex flex-row items-center text-text-default t-body-sm'
});

export const Trim = createComponent('span', {
  className:
    'overflow-hidden text-ellipsis whitespace-nowrap sm:max-w-[60%] lg:max-w-[75%]'
});

export const FavoriteWrapper = createComponent('div', {
  className: 'absolute right-0 z-1 flex h-44 w-44 items-center justify-center'
});

export const SkeletonTextSmall = createComponent(Pulser, {
  className: 'h-16'
});

export const SkeletonTextMedium = createComponent(Pulser, {
  className: 'h-20 h-40'
});

export const SkeletonTextLarge = createComponent(Pulser, {
  className: 'h-48 sm:h-64'
});

export const SkeletonImage = createComponent(Pulser, {
  className: 'h-[42vw] h-full w-full min-w-[50%] sm:h-[268px] md:h-[278px]'
});
